var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"50","cy":"50","r":"48","fill":"white","stroke":"black","strokeWidth":"4","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M39 29V69H43L43 29H39ZM58 29L58 69H62L62 29H58Z","fill":"black","key":1})]);
}

Pause.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Pause;

Pause.default = Pause;
